export const messages = {
  something: 'Something went wrong. Please try again.',
  emailExist: 'The email address already exists.',
  numberExist: 'The number already exists.',
  user: 'The user not found.',
  invalidCredential: 'Invalid email or password.',
  clubPortalOnly:
    'This account cannot access the club portal. Sign in with a club account (e.g. club-1@seed.tee-swap.test).',
  networkError: 'Unable to reach the server. Check your connection and that the API is running.'
}

export const responseCases = {
  NUMBER_EXIST: 'NUMBER_EXIST',
  EMAIL_EXIST: 'EMAIL_EXIST',
  ALREADY_EXIST: 'ALREADY_EXIST',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
  CLUB_PORTAL_ONLY: 'CLUB_PORTAL_ONLY'
}
